// extracted by mini-css-extract-plugin
module.exports = {"orderMainDiv":"msil_orderMainDiv__2-Yua"};